import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MESSAGES = [
  "Preparing the treats...",
  "Getting the bubbles ready...",
  "Calling our groomers...",
  "Almost there...",
];

export default function LoadingScreen({ onDone }) {
  const [msg, setMsg] = useState(0);
  useEffect(() => {
    const int = setInterval(() => setMsg((m) => Math.min(m + 1, MESSAGES.length - 1)), 700);
    const done = setTimeout(() => onDone?.(), 3000);
    return () => { clearInterval(int); clearTimeout(done); };
  }, [onDone]);

  return (
    <motion.div data-testid="loading-screen"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-woofsy-bg overflow-hidden"
      exit={{ opacity: 0, transition: { duration: 0.6 } }}>
      {/* paw prints trail */}
      <div className="absolute bottom-1/3 left-0 w-full h-24">
        {Array.from({ length: 9 }).map((_, i) => (
          <motion.svg key={i} viewBox="0 0 24 24" fill="#FF8A3D"
            className="absolute w-6 h-6" style={{ left: `${8 + i * 10}%`, top: i % 2 ? 0 : 40 }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: [0, 0.7, 0.7], scale: 1 }}
            transition={{ delay: 0.2 + i * 0.28, duration: 0.4 }}>
            <circle cx="6" cy="9" r="2.2" /><circle cx="12" cy="6.5" r="2.2" />
            <circle cx="18" cy="9" r="2.2" /><circle cx="9" cy="13" r="2.2" />
            <ellipse cx="12" cy="18" rx="4.5" ry="3.6" />
          </motion.svg>
        ))}
      </div>

      {/* running puppy */}
      <motion.div className="absolute bottom-[38%] text-6xl"
        initial={{ x: "-30vw" }} animate={{ x: "30vw" }}
        transition={{ duration: 3, ease: "easeInOut" }}>
        <motion.div animate={{ y: [0, -14, 0] }} transition={{ duration: 0.5, repeat: Infinity }}>
          <span className="inline-block" style={{ transform: "scaleX(-1)" }}>🐕</span>
        </motion.div>
      </motion.div>

      <motion.div initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 160 }}
        className="flex flex-col items-center gap-3 mb-6">
        <img src="/logo.png" alt="Woofsy Logo" className="h-32 sm:h-40 w-auto object-contain filter drop-shadow-md animate-pulse" />

      </motion.div>

      <div className="h-6">
        <AnimatePresence mode="wait">
          <motion.p key={msg} data-testid="loading-message"
            initial={{ y: 12, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -12, opacity: 0 }}
            className="text-woofsy-dark/70 font-medium">{MESSAGES[msg]}</motion.p>
        </AnimatePresence>
      </div>

      <div className="mt-6 w-56 h-2 rounded-full bg-woofsy-primary/15 overflow-hidden">
        <motion.div className="h-full bg-woofsy-primary rounded-full"
          initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 3, ease: "easeInOut" }} />
      </div>
    </motion.div>
  );
}
